import React, { useEffect, useRef } from "react";
import search from "../../images/icons/search.png";
import "../CustomSearchBar/CustomSearchBar.css";

const CustomSearchBar = ({ value, setValue, onSearch }) => {
  const prevValueRef = useRef();

  const handleChange = (e) => {
    const searchValue = e.target.value;
    setValue(searchValue);
  };

  const handleBlur = () => {
    setValue((prevValue) => prevValue);
  };

  useEffect(() => {
    if (value !== prevValueRef.current) {
      onSearch(value);
    }

    prevValueRef.current = value;
  }, [value, onSearch]);

  return (
    <div className="search-container">
      <input
        type="text"
        className="searchInput"
        placeholder="Search"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <button className="btnSearch" onClick={onSearch}>
        <img src={search} className="imgIcon" alt="search" />
      </button>
    </div>
  );
};

export default CustomSearchBar;
